<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<!-- <div class="col-6">
							<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
							</div> -->
							<div class="col">
							<button type="button" class="close" @click="$emit('closeModal')">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body">
							<h4 class="title">SPK Asuransi</h4>

              <div v-if="!no_spk">
                <div class="row row-space">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="input-group">
                      <label class="label">Nomor SPK Asuransi<span style="color: red;">*</span></label>
                      <input class="input--style-4" type="text" v-model="no_spk_temp">
                    </div>
                  </div>
                </div>

                <div class="row row-space">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="input-group">
                      <label class="label">Unggah Dokumen SPK Asuransi<span style="color: red;">*</span></label>
                      <input type="file"  class="input--style-4" accept="application/pdf,image/*" @change="validateSize" multiple/>
                    </div>
                  </div>
                </div>
                <div class="row row-space">
                  <div class="col-xs-12 col-md-6">
                    <div class="input-group">
                      <label class="label">Jumlah OR<span style="color: red;">*</span></label>
                      <input id="or_price" pattern="^[0-9]+$" class="input--style-4"  type="text"  v-model="orCount">
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <div class="input-group">
                      <label class="label">Harga Per OR<span style="color: red;">*</span></label>
                      <input id="or_count" pattern="^[0-9]+$" class="input--style-4"  type="text"  v-model="orPrice">
                    </div>
                  </div>
                </div>

                <div class="row row-space">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="input-group">
                      <label class="label">Total Harga<span style="color: red;">*</span></label>
                      <input class="input--style-4" style="background-color:#aaa" disabled type="text"  v-model="ownRiskPrice">
                    </div>
                  </div>
                </div>

                

                <div class="row">
                  <div class="col mt-5" style="text-align: center">
                    <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                    <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm('Main')">Unggah</button>
                  </div>
                </div>
              </div>

              <div v-else>
                <div class="row pl-3 pr-3">
                  <div class="col-6">
                    <h5>No SPK Asuransi :</h5>
                  </div>
                  <div class="col-6">
                    {{no_spk}}
                  </div>
                </div>


                <div class="pl-3 pr-3">
                  <h5 class="mt-2">Dokumen Tersedia</h5>

                  <table class="table table-bordered">
                    <thead>
                      <th>No.</th>
                      <th>Nama Dokumen</th>
                      <th>Tipe Dokumen</th>
                      <th>Tanggal Unggah</th>
                      <th>Unduh Dokumen</th>
                    </thead>
                    <tbody v-for="(spk_document, index) in spk_documents_parsed" :key="index">
                      <tr>
                        <td>{{index  + 1}}</td>
                        <td>{{spk_document.name}}</td>
                        <td>{{spk_document.type}}</td>
                        <td>{{moment(spk_document.created_at).format("DD MMM Y hh:mm A")}}</td>
                        <td><button @click="openDocument(spk_document.name)" class="btn  btn-info">Unduh Dokumen</button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <br>

                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="input-group">
                      <label class="label">Unggah Dokumen Supplementary SPK<span style="color: red;">*</span></label>
                      <input type="file"  class="input--style-4" accept="application/pdf,image/*" @change="validateSize" multiple/>
                    </div>
                  </div>
                </div>
                <div class="row row-space">
                  <div class="col-xs-12 col-md-6">
                    <div class="input-group">
                      <label class="label">Jumlah OR<span style="color: red;">*</span></label>
                      <input pattern="^[0-9]+$" class="input--style-4"  type="text"  v-model="orCount">
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <div class="input-group">
                      <label class="label">Harga Per OR<span style="color: red;">*</span></label>
                      <input pattern="^[0-9]+$" class="input--style-4"  type="text"  v-model="orPrice">
                    </div>
                  </div>
                </div>

                <div class="row row-space">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="input-group">
                      <label class="label">Total Harga Sebelumnya<span style="color: red;">*</span></label>
                      <input class="input--style-4" type="text"  v-model="ownRiskPrice" disabled>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col mt-5" style="text-align: center">
                    <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                    <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm('Supplementary')">Unggah</button>
                  </div>
                </div>
                
              </div>

						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import moment from 'moment'
import env from '@/env'
export default {
	data () {
		return {
      no_spk : this.data.details.no_spk,
      no_spk_temp : '',
      file : null,
      spk_documents_parsed : [],
      moment : moment,
      ownRiskPrice : null,
      orCount : null,
      orPrice : null,
      uploading : false
		}
	},
  mounted() {
    this.data[this.variable] = parseInt(this.data[this.variable])
    console.log(this.data.details)
    this.parseSPK()

		this.ownRiskPrice = parseInt(this.data.details.own_risk).toString();
  },
	watch : {
		ownRiskPrice : function () {
      //Clear 0 if 0 is first one
      this.ownRiskPrice = this.ownRiskPrice.toString()
			const result = this.ownRiskPrice.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.ownRiskPrice = result);
    },
    orCount : function () {
      if(!this.orCount || !this.orPrice) return
      
      this.ownRiskPrice = parseFloat(this.orPrice.split(',').join('')) * parseInt(this.orCount)
      
    },
    orPrice : function () {
      if(!this.orCount || !this.orPrice) return
      this.ownRiskPrice = parseFloat(this.orPrice.split(',').join('')) * parseInt(this.orCount)
      const result = this.orPrice.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.orPrice = result);
    }
	},
	methods : {
    // downloadFile(link) {

    // },
    openDocument (url) {
			window.open(`${env.baseImage}/${url}`, "_blank");
		},
    parseSPK () {
      for(var i = 0 ; i < this.spk_documents.length; i++) {
        let obj = {}

        let splitName =  this.spk_documents[i].file.split('/')
        obj.name = splitName[splitName.length - 1]

        // obj.timeOfUpload = obj.name.split(' - ')[1].replace('.pdf', '')
        obj.link = this.spk_documents[i].file
        obj.type = this.spk_documents[i].spk_type
        obj.created_at = this.spk_documents[i].created_at

        this.spk_documents_parsed.push(obj)
      }
    },
		validateSize : function(data){
			
      var file = data.target.files;

      if(file.length > 1) {
          this.fileError = "Maksimum Dokumen Di Unggah : 1 Dokumen";
          return false;
      }

      var size  = file.size / 1024 / 1024;

      if(size > 20)
      {
          this.fileError = "Maksimum Size Dokumen 10 MB";
          return false;
      }

      this.fileError = "";
      this.file = file
      return true;
		},
		validateForm(type){
			var valid = true;
			var error = [];
			

			if(this.file == '' || this.file == null){//Sparepart [Required]
				valid = false;
				error.push('File SPK Tidak boleh kosong!');
			}

      let spkVar = ''
      if(type == 'Main')
          spkVar = 'no_spk_temp'
        else
          spkVar = 'no_spk'

			if(this[spkVar] == '' || this[spkVar] == null){//Sparepart [Required]
				valid = false;
				error.push('Nomor SPK Tidak boleh kosong!');
      }
      
      if(this[spkVar].includes('/')) {
        valid = false;
        error.push('Nomor SPK Tidak Boleh Mengandung "/"!')
      }
      
      if(isNaN(this.ownRiskPrice.split(',').join(''))) {
        valid = false;
        error.push('Own risk harus berbentuk angka!')
      }

			if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        	else return valid;
		},
		submitForm(type) {
      if(this.uploading) {
        this.$store.dispatch('triggerAlert' , [false , 'Upload sedang berlangsung. mohon ditunggu.'])
        return
      }

      this.uploading = true

			if(this.validateForm(type)){
				let formData = new FormData()
				console.log(this.data.details)

				// formData.append('work_order_code' , this.form_code)
				// formData.append('insurance_id' , this.data.details.insurance_id)
				// formData.append('discount' , this.data.details.discount)
				// formData.append('own_risk' ,this.data.details.own_risk)
        // formData.append('derek' , this.data.details.derek)
        if(type == 'Main')
          formData.append('no_spk' , this.no_spk_temp)
        else
          formData.append('no_spk' , this.no_spk)
        
        formData.append('or_price_per_panel' , parseFloat(this.orPrice.split(',').join('')))
        formData.append('num_panel' , parseInt(this.orCount))
        formData.append('file' , this.file[0])
        formData.append('spk_type' , 'SPK')

				this.$http.post(`api/v1/workorder-estimation/${this.form_code}/spk`, formData ,  {headers : {"Content-Type":'multipart/form-data'}})
				.then((resp) => {
          this.submitOwnRisk();
          this.uploading = false

        })
				.catch((err) => {
					console.log(err)
          this.uploading = false
				})
			}
			
    },
    submitOwnRisk(){
			let data = {
        own_risk : parseFloat(this.ownRiskPrice.split(',').join(''))
      }
      this.$http.patch('/api/v1/workorder-estimation/' + this.form_code , data)
      .then((resp) => {
        this.$store.dispatch('triggerAlert', [true, [`No SPK Berhasil Di Input`]]);
        this.$emit('updateTable');
        this.$emit('closeModal');
      })
      .catch((err) => {
        console.log(err)
      })
    }
	},
	props : ['data' , 'type' , 'variable', 'form_code' , 'spk_documents']
}
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
